import React, { Component } from 'react';
import routes from "./routes";
import {
  Route,
  Routes,
} from "react-router-dom";
// import "./assets/scss/theme.scss";

// import "../../../public/assets/css/themify-icons.css";

class App extends Component {
  render() {
    return (
      <React.Fragment>       
          <Routes>
            {routes.map((route, idx) => (
              <Route path={route.path} element={route.component} key={idx} />
            ))}
          </Routes>
      </React.Fragment>
    )
  }
}

export default App;